"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _rcMenu = _interopRequireWildcard(require("rc-menu"));
var _domClosest = _interopRequireDefault(require("dom-closest"));
var _classnames = _interopRequireDefault(require("classnames"));
var _shallowequal = _interopRequireDefault(require("shallowequal"));
var _filterDropdownMenuWrapper = _interopRequireDefault(require("./filterDropdownMenuWrapper"));
var _Helpers = require("./../../Helpers");
var _ykbUtils = require("ykb-utils");
var _Dropdown = _interopRequireDefault(require("../../../Dropdown"));
var _Icon = _interopRequireDefault(require("../../../Icon"));
var _Button = _interopRequireDefault(require("../../../Button"));
var _Checkbox = _interopRequireDefault(require("../../../Checkbox"));
var _Radio = require("../../../Radio");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function stopPropagation(e) {
  e.stopPropagation();
  if (e.nativeEvent.stopImmediatePropagation) {
    e.nativeEvent.stopImmediatePropagation();
  }
}
var FilterMenu = /*#__PURE__*/function (_React$Component) {
  function FilterMenu(props) {
    var _this;
    (0, _classCallCheck2.default)(this, FilterMenu);
    _this = _callSuper(this, FilterMenu, [props]);
    (0, _defineProperty2.default)(_this, "neverShown", void 0);
    (0, _defineProperty2.default)(_this, "getPopupContainer", function () {
      var _trigger$parentElemen, _trigger$parentElemen2, _trigger$parentElemen3, _trigger$parentElemen4, _trigger$parentElemen5;
      var trigger = _reactDom.default.findDOMNode(_this);
      var tableContainer = trigger === null || trigger === void 0 ? void 0 : (_trigger$parentElemen = trigger.parentElement) === null || _trigger$parentElemen === void 0 ? void 0 : (_trigger$parentElemen2 = _trigger$parentElemen.parentElement) === null || _trigger$parentElemen2 === void 0 ? void 0 : (_trigger$parentElemen3 = _trigger$parentElemen2.parentElement) === null || _trigger$parentElemen3 === void 0 ? void 0 : (_trigger$parentElemen4 = _trigger$parentElemen3.parentElement) === null || _trigger$parentElemen4 === void 0 ? void 0 : (_trigger$parentElemen5 = _trigger$parentElemen4.parentElement) === null || _trigger$parentElemen5 === void 0 ? void 0 : _trigger$parentElemen5.parentElement;
      return tableContainer ? tableContainer : trigger;
    });
    (0, _defineProperty2.default)(_this, "generatePopupContainerFunc", function () {
      var scroll = _this.props.scroll;

      // Use undefined to let rc component use default logic.
      return scroll ? _this.getPopupContainer : function () {
        return (0, _ykbUtils.containerChecker)(_this.getPopupContainer());
      };
    });
    (0, _defineProperty2.default)(_this, "setNeverShown", function (column) {
      var rootNode = _reactDom.default.findDOMNode(_this);
      var filterBelongToScrollBody = !!(0, _domClosest.default)(rootNode, ".ant-table-scroll");
      if (filterBelongToScrollBody) {
        // When fixed column have filters, there will be two dropdown menus
        // Filter dropdown menu inside scroll body should never be shown
        // To fix https://github.com/ant-design/ant-design/issues/5010 and
        // https://github.com/ant-design/ant-design/issues/7909
        _this.neverShown = !!column.fixed;
      }
    });
    (0, _defineProperty2.default)(_this, "setSelectedKeys", function (_ref) {
      var selectedKeys = _ref.selectedKeys;
      _this.setState({
        selectedKeys: selectedKeys
      });
    });
    (0, _defineProperty2.default)(_this, "handleClearFilters", function () {
      _this.setState({
        selectedKeys: []
      }, _this.handleConfirm);
    });
    (0, _defineProperty2.default)(_this, "handleConfirm", function () {
      _this.setVisible(false);

      // Call `setSelectedKeys` & `confirm` in the same time will make filter data not up to date
      // https://github.com/ant-design/ant-design/issues/12284
      _this.setState({}, _this.confirmFilter);
    });
    (0, _defineProperty2.default)(_this, "onVisibleChange", function (visible) {
      _this.setVisible(visible);
      if (visible) _this.setState({
        menus: _this.prepareOverlayMenu()
      });else {
        _this.confirmFilter();
      }
    });
    (0, _defineProperty2.default)(_this, "handleRadioCheckboxClick", function (e) {
      e.stopPropagation();
      if (e.nativeEvent.stopImmediatePropagation) {
        e.nativeEvent.stopImmediatePropagation();
      }
    });
    (0, _defineProperty2.default)(_this, "handleMenuItemClick", function (info) {
      var selectedKeys = _this.state.selectedKeys;
      if (!info.keyPath || info.keyPath.length <= 1) {
        return;
      }
      var keyPathOfSelectedItem = _this.state.keyPathOfSelectedItem;
      if (selectedKeys && selectedKeys.indexOf(info.key) >= 0) {
        // deselect SubMenu child
        delete keyPathOfSelectedItem[info.key];
      } else {
        // select SubMenu child
        keyPathOfSelectedItem[info.key] = info.keyPath;
      }
      _this.setState({
        keyPathOfSelectedItem: keyPathOfSelectedItem
      });
    });
    (0, _defineProperty2.default)(_this, "renderFilterIcon", function () {
      var _this$props = _this.props,
        column = _this$props.column,
        locale = _this$props.locale,
        prefixCls = _this$props.prefixCls,
        selectedKeys = _this$props.selectedKeys;
      var filtered = selectedKeys && selectedKeys.length > 0;
      var filterIcon = column.filterIcon;
      if (typeof filterIcon === 'function') {
        filterIcon = filterIcon(filtered);
      }
      var dropdownIconClass = (0, _classnames.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-icon"), true), "".concat(prefixCls, "-icon-selected"), filtered), "".concat(prefixCls, "-icon-open"), _this.getDropdownVisible()));
      return filterIcon ? (/*#__PURE__*/_react.default.cloneElement(filterIcon, {
        title: locale.filterTitle,
        className: (0, _classnames.default)("".concat(prefixCls, "-icon"), dropdownIconClass, filterIcon.props.className),
        onClick: stopPropagation
      })) : /*#__PURE__*/_react.default.createElement("span", {
        className: dropdownIconClass,
        onClick: stopPropagation
      }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        title: locale.filterTitle,
        name: "filter",
        size: "small"
      }));
    });
    (0, _defineProperty2.default)(_this, "prepareOverlayMenu", function () {
      var originSelectedKeys = _this.state.selectedKeys;
      var _this$props2 = _this.props,
        column = _this$props2.column,
        locale = _this$props2.locale,
        prefixCls = _this$props2.prefixCls,
        dropdownPrefixCls = _this$props2.dropdownPrefixCls,
        data = _this$props2.data;
      // default multiple selection in filter dropdown
      var multiple = 'filterMultiple' in column ? column.filterMultiple : true;
      var dropdownMenuClass = (0, _classnames.default)((0, _defineProperty2.default)({}, "".concat(dropdownPrefixCls, "-menu-without-submenu"), !_this.hasSubMenu()));
      var filterDropdown = column.filterDropdown;
      if (filterDropdown instanceof Function) {
        filterDropdown = filterDropdown({
          prefixCls: "".concat(dropdownPrefixCls, "-menu"),
          setSelectedKeys: function setSelectedKeys(selectedKeys) {
            return _this.setSelectedKeys({
              selectedKeys: selectedKeys
            });
          },
          selectedKeys: originSelectedKeys,
          confirm: _this.handleConfirm,
          clearFilters: _this.handleClearFilters,
          filters: column.filters,
          getPopupContainer: function getPopupContainer(triggerNode) {
            return triggerNode.parentNode;
          },
          data: data
        });
      }
      var menus = filterDropdown && typeof filterDropdown !== 'boolean' ? /*#__PURE__*/_react.default.createElement(_filterDropdownMenuWrapper.default, {
        className: "".concat(prefixCls, "-dropdown")
      }, filterDropdown) : /*#__PURE__*/_react.default.createElement(_filterDropdownMenuWrapper.default, {
        className: "".concat(prefixCls, "-dropdown")
      }, /*#__PURE__*/_react.default.createElement(_rcMenu.default, {
        multiple: multiple,
        onClick: _this.handleMenuItemClick,
        prefixCls: "".concat(dropdownPrefixCls, "-menu"),
        className: dropdownMenuClass,
        onSelect: _this.setSelectedKeys,
        onDeselect: _this.setSelectedKeys,
        selectedKeys: originSelectedKeys && originSelectedKeys.map(function (val) {
          return val.toString();
        }),
        getPopupContainer: function getPopupContainer(triggerNode) {
          return triggerNode.parentNode;
        }
      }, _this.renderMenus(column.filters || [])), /*#__PURE__*/_react.default.createElement("div", {
        className: "dropdown-buttons"
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        size: "small",
        type: "secondary",
        onClick: _this.handleClearFilters
      }, locale.filterReset), /*#__PURE__*/_react.default.createElement(_Button.default, {
        size: "small",
        type: "primary",
        className: "pull-right",
        onClick: _this.handleConfirm
      }, locale.filterConfirm)));
      return menus;
    });
    var _visible = 'filterDropdownVisible' in props.column ? props.column.filterDropdownVisible : false;
    _this.state = {
      selectedKeys: props.selectedKeys,
      valueKeys: _Helpers.Utils.generateValueMaps(props.column.filters),
      keyPathOfSelectedItem: {},
      // 记录所有有选中子菜单的祖先菜单
      visible: _visible,
      prevProps: props,
      menus: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)
    };
    return _this;
  }
  (0, _inherits2.default)(FilterMenu, _React$Component);
  return (0, _createClass2.default)(FilterMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var column = this.props.column;
      this.setNeverShown(column);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var column = this.props.column;
      this.setNeverShown(column);
    }
  }, {
    key: "getDropdownVisible",
    value: function getDropdownVisible() {
      return this.neverShown ? false : this.state.visible;
    }
  }, {
    key: "setVisible",
    value: function setVisible(visible) {
      var column = this.props.column;
      if (!('filterDropdownVisible' in column)) {
        this.setState({
          visible: visible
        });
      }
      if (column.onFilterDropdownVisibleChange) {
        column.onFilterDropdownVisibleChange(visible);
      }
    }
  }, {
    key: "confirmFilter",
    value: function confirmFilter() {
      var _this$state = this.state,
        selectedKeys = _this$state.selectedKeys,
        valueKeys = _this$state.valueKeys;
      var filterDropdown = this.props.column.filterDropdown;
      if (!(0, _shallowequal.default)(selectedKeys, this.props.selectedKeys)) {
        this.props.confirmFilter(this.props.column, filterDropdown ? selectedKeys : selectedKeys.map(function (key) {
          return valueKeys[key];
        }));
      }
    }
  }, {
    key: "renderMenuItem",
    value: function renderMenuItem(item) {
      var _item$value, _item$value2;
      var column = this.props.column;
      var selectedKeys = this.state.selectedKeys;
      var multiple = 'filterMultiple' in column ? column.filterMultiple : true;

      // We still need trade key as string since Menu render need string
      var internalSelectedKeys = (selectedKeys || []).map(function (key) {
        return key.toString();
      });
      var input = multiple ? /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
        onClick: this.handleRadioCheckboxClick,
        checked: internalSelectedKeys.indexOf(item === null || item === void 0 ? void 0 : (_item$value = item.value) === null || _item$value === void 0 ? void 0 : _item$value.toString()) >= 0
      }) : /*#__PURE__*/_react.default.createElement(_Radio.Radio, {
        onClick: this.handleRadioCheckboxClick,
        checked: internalSelectedKeys.indexOf(item === null || item === void 0 ? void 0 : (_item$value2 = item.value) === null || _item$value2 === void 0 ? void 0 : _item$value2.toString()) >= 0
      });
      return /*#__PURE__*/_react.default.createElement(_rcMenu.Item, {
        key: item.value
      }, input, /*#__PURE__*/_react.default.createElement("span", null, item.text));
    }
  }, {
    key: "hasSubMenu",
    value: function hasSubMenu() {
      var _this$props$column$fi = this.props.column.filters,
        filters = _this$props$column$fi === void 0 ? [] : _this$props$column$fi;
      return filters.some(function (item) {
        return !!(item.children && item.children.length > 0);
      });
    }
  }, {
    key: "renderMenus",
    value: function renderMenus(items) {
      var _this2 = this;
      return items.map(function (item) {
        if (item.children && item.children.length > 0) {
          var _item$value3;
          var keyPathOfSelectedItem = _this2.state.keyPathOfSelectedItem;
          var containSelected = Object.keys(keyPathOfSelectedItem).some(function (key) {
            return keyPathOfSelectedItem[key].indexOf(item.value) >= 0;
          });
          var subMenuCls = containSelected ? "".concat(_this2.props.dropdownPrefixCls, "-submenu-contain-selected") : '';
          return /*#__PURE__*/_react.default.createElement(_rcMenu.SubMenu, {
            title: item.text,
            className: subMenuCls,
            key: item === null || item === void 0 ? void 0 : (_item$value3 = item.value) === null || _item$value3 === void 0 ? void 0 : _item$value3.toString()
          }, _this2.renderMenus(item.children));
        }
        return _this2.renderMenuItem(item);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var prefixCls = this.props.prefixCls;
      return /*#__PURE__*/_react.default.createElement(_Dropdown.default, {
        trigger: ['click'],
        placement: "bottomRight",
        overlayClassName: "".concat(prefixCls, "-dropdown-overlay"),
        overlay: this.state.menus,
        visible: this.getDropdownVisible(),
        onVisibleChange: this.onVisibleChange,
        getPopupContainer: this.generatePopupContainerFunc()
      }, this.renderFilterIcon());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var column = nextProps.column;
      var prevProps = prevState.prevProps;
      var newState = {
        prevProps: nextProps
      };

      /**
       * if the state is visible the component should ignore updates on selectedKeys prop to avoid
       * that the user selection is lost
       * this happens frequently when a table is connected on some sort of realtime data
       * Fixes https://github.com/ant-design/ant-design/issues/10289 and
       * https://github.com/ant-design/ant-design/issues/10209
       */
      if ('selectedKeys' in nextProps && !(0, _shallowequal.default)(prevProps.selectedKeys, nextProps.selectedKeys)) {
        newState.selectedKeys = nextProps.selectedKeys;
      }
      if (!(0, _shallowequal.default)((prevProps.column || {}).filters, (nextProps.column || {}).filters)) {
        newState.valueKeys = _Helpers.Utils.generateValueMaps(nextProps.column.filters);
      }
      if ('filterDropdownVisible' in column) {
        newState.visible = column.filterDropdownVisible;
      }
      return newState;
    }
  }]);
}(_react.default.Component); // polyfill(FilterMenu);
(0, _defineProperty2.default)(FilterMenu, "defaultProps", {
  handleFilter: function handleFilter() {},
  column: {}
});
var _default = exports.default = FilterMenu;